import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tag } from 'primereact/tag';
import { useDataTable } from '@iamsoftware/react-hooks';
import { AgreementService } from 'src/app/hop-dong/quan-ly-hop-dong/AgreementService';

export const TaiLieuDaNhan: React.FC = () => {
  const navigate = useNavigate();
  const [headerResult, setHeaderResult] = useState<any>(null);

  useEffect(() => {
    setHeaderResult(
      <div className="flex align-items-center justify-content-between ">
        <span>Tài liệu đến</span>
      </div>
    );
  }, []);

  const { render, reloadLazyData } = useDataTable({
    tableHeader: headerResult,
    dataKey: 'agreementId',
    indexColumnWidth: 45,
    actionColumnWidth: 112,
    columns: [
      { field: 'agreementName', header: 'Hợp đồng', width: 220, matchMode: 'contains', dataType: 'custom', customCell(row) {
          return <span className="underline text-primary" onClick={() => navigate(`/quan-ly-tai-lieu/tai-lieu/${row.agreementId}?mode=view`)} title="Xem chi tiết">{row.agreementName}</span>
        }
      },
      { field: 'agreementPseudoId', header: 'Mã hợp đồng', width: 140, matchMode: 'contains' },
      { field: 'agreementTypeName', header: 'Loại hợp đồng', width: 160, matchMode: 'contains' },
      { field: 'statusDescription', header: 'Trạng thái', width: 140, matchMode: 'contains', dataType: 'custom', customCell(row) {
          const map: any = {
            'AGT_SIGNING_PROCESS': { severity: 'warning', label: 'Đang xử lý' },
            'AGT_SIGN_COMPLETED': { severity: 'success', label: 'Hoàn thành' },
            'AGT_CANCELLED': { severity: 'danger', label: 'Đã hủy' }
          };
          const s = map[row.statusId] || { severity: 'secondary', label: row.statusDescription || 'N/A' };
          return <Tag value={s.label} severity={s.severity as any} />;
        }
      },
      { field: 'mainContent', header: 'File chính', width: 220, dataType: 'custom', customCell(row) {
          if (!row.mainContent) return <span className="text-gray-500">Chưa có file</span>;
          return (
            <div className="flex align-items-center gap-2">
              <i className={`pi ${row.mainContent.contentType === 'application/pdf' ? 'pi-file-pdf' : 'pi-file-word'} text-xl`}></i>
              <div>
                <div className="font-medium">{row.mainContent.fileName}</div>
                <small className="text-gray-500">{row.mainContent.contentType?.split('/')?.[1]?.toUpperCase()}</small>
              </div>
            </div>
          );
        }
      },
      { field: 'contentCount', header: 'Số file', width: 110 },
      { field: 'lastUpdatedStamp', header: 'Thời gian', width: 160, dataType: 'date' }
    ],
    getList: lazyLoadEvent => {
      return AgreementService.getAgreementList(lazyLoadEvent, 'AGT_RECEIVED').then(result => {
        return {
          listData: result.listData || [],
          totalCount: result.totalRecords || (result.listData || []).length
        };
      });
    },
    initActions(items: Array<any>) {
      items?.forEach(item => {
        item.actions = [
          { icon: 'pi pi-eye', title: 'Xem chi tiết', className: 'p-button-info', command: () => navigate(`/quan-ly-tai-lieu/tai-lieu/${item.agreementId}?mode=view`) }
        ];
      });
    }
  });

  useEffect(() => { reloadLazyData(); }, []);

  return (
    <div className="grid">
      <div className="col-12">
        <h3 className="m-0 mb-2">Tài liệu đến</h3>
      </div>
      <div className="col-12 pb-0" style={{maxHeight: 'calc(100vh - 12rem)'}}>
        {render()}
      </div>
    </div>
  );
};
